export default "__VITE_ASSET__DaU46lua__"